export const I18n = {
	'en': {
		companiesRemove: 'Companies - delete',
		companiesAdd: 'Companies - add',
		companiesList: 'Companies List',
		title: 'Apps attributes',
		searchPlaceholder: 'Search...',
		allViews: 'All views',
		addAttr: 'Add attribute',
		tableTitle: 'Title',
		view: 'View',
		type: 'Type',
		defaultValue: 'Default value',
		permittedValues: 'Permitted values',
		editable: 'Editable',
		companies: 'Companies',
		mapping: 'Mapping',
		comments: 'Comments',

		modal: {
			sure: 'Are you sure ?',
			save: 'Save',
			cancel: 'Cancel',
			delete: 'Delete',
			add_edit: 'Add / Edit attribute',
			labelName: 'Name',
			labelView: 'View',
			labelType: 'Type',
			defaultValue: 'Default value',
			permittedValues: 'Permitted values',
			permittedPlaceholder: 'Add',
			mapping: 'Mapping',
			comments: 'Comments',
			label: 'Label',
			editableByCompany: 'Editable item',
			companyList: 'Companies List:',
			selectedByCompany: 'Selected by name...',
			addCompany: 'Add company',
		}
	},
	'ru': {
		companiesRemove: 'Компании - удалить',
		companiesAdd: 'Компании - добавить',
		companiesList: 'Список компаний',
		title: 'Атрибуты приложений',
		searchPlaceholder: 'Поиск...',
		allViews: 'Все виды',
		addAttr: 'Добавить атрибут',
		tableTitle: 'Название',
		view: 'Вид',
		type: 'Тип',
		defaultValue: 'Значение по умолчанию',
		permittedValues: 'Допустимые значения',
		editable: 'Возможность редактировать',
		companies: 'Компании',
		mapping: 'Маппинг',
		comments: 'Комментарии',
		modal: {
			sure: 'Вы уверены ?',
			save: 'Сохранить',
			cancel: 'Отмена',
			delete: 'Удалить',
			add_edit: 'Добавить / Изменить аттрибут',
			labelName: 'Название',
			labelView: 'Вид',
			labelType: 'Тип',
			defaultValue: 'Значение по умолчанию',
			permittedValues: 'Допустимые значения',
			permittedPlaceholder: 'Добавить',
			mapping: 'Маппинг',
			comments: 'Комментарии',
			label: 'Лейбл',
			editableByCompany: 'Возможность редактирования',
			companyList: 'Список компаний:',
			selectedByCompany: 'Выбор по имени...',
			addCompany: 'Добавить компанию'
		}
	},
	'sk': {
		companiesRemove: 'FIRMY - zmazať',
		companiesAdd: 'FIRMY - pridať',
		companiesList: 'Zoznam firiem',
		title: 'Atribúty Apps',
		searchPlaceholder: 'Vyhľadávanie...',
		allViews: 'Všetky pohľady',
		addAttr: 'Pridať atribút',
		tableTitle: 'Nadpis',
		view: 'Vyhliadka',
		type: 'Typ',
		defaultValue: 'Predvolená hodnota',
		permittedValues: 'Povolenej hodnoty',
		editable: 'Editovateľné',
		companies: 'Firmy',
		mapping: 'Mapovanie',
		comments: 'Komentáre',
		modal: {
			sure: 'Si si istý ?',
			save: 'Uložiť',
			cancel: 'Zrušiť',
			delete: 'Vymazať',
			add_edit: 'Pridať / Upraviť atribút',
			labelName: 'Názov',
			labelView: 'Vyhliadka',
			labelType: 'Typ',
			defaultValue: 'Predvolená hodnota',
			permittedValues: 'Povolenej hodnoty',
			permittedPlaceholder: 'Pridať',
			mapping: 'Mapovanie',
			comments: 'Komentáre',
			label: 'štítok',
			editableByCompany: 'Editovateľné položka',
			companyList: 'Firmy Zoznam:',
			selectedByCompany: 'Vybraný podľa názvu ...',
			addCompany: 'Pridať firmu'
		}
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/attributes/index.js